//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiCell from "../../components/cell/Index.vue";
import HiButton from "../../components/button/Index.vue";
import HiHeader from "../../components/header/Index.vue";
import { validationMixin } from "vuelidate";
import { email, required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";

export default {
  name: "TeamMemberInviteMemberPage",
  components: { HiCell, HiHeader, HiButton },
  mixins: [validationMixin],
  validations: {
    form: {
      email: {
        email,
        required,
      },
    },
  },
  data() {
    const _this = this;
    return {
      statement: [
        _this.$t("inviteMemberPage.des1"),
        _this.$t("inviteMemberPage.des2"),
        _this.$t("inviteMemberPage.des3"),
        "You or member can review and approve the schedules before they get posted.",
      ],
      form: {
        email: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     *  可添加用户数量
     */
    allowAddNum() {
      return this.user.linkedInstagramList.filter(
        (l) => !l.isMember && l.status === 1
      );
    },
  },
  methods: {
    /**
     * next按钮点击事件，跳转到assign Instagram 页面
     */
    async nextClick() {
      // 获取用户所有member
      const hasSameEmail = this.user.teamMemberList.find(
        (m) => m.memberEmail === this.form.email
      );

      // 验证邮箱是否被重复邀请过
      if (hasSameEmail) {
        await this.$alert.show(this.$t("inviteMemberPage.sameEmailMsg"));
        return;
      }
      // 如果当前账号是自己弹出提示
      if (this.user.email === this.form.email) {
        await this.$alert.show(this.$t("inviteMemberPage.isMeEmail"));
        return;
      }
      // 验证是否还存在可以选择的ins用户
      // if (this.allowAddNum <= 0) {
      //   // 如果一个可添加用户都不存在则弹出该提示
      //   await this.$confirm.show({
      //     text: this.$t('inviteMemberPage.isInsNulText'),
      //     yesText: this.$t('inviteMemberPage.add')
      //   })
      //   this.$router.push({name: 'LoginInstagramPage'})
      //   return
      // }
      this.$router.push({
        name: "TeamMemberAssignInstagramPage",
        params: { email: this.form.email },
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      if (from.name === "MyPlanPage") {
        vm.form.email = "";
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/pages/team_member/InviteMember.vue